import React, { useState } from 'react';

import { BaseBanner } from 'src/components/BaseBanner';
import { BaseSearch } from 'src/components/BaseSearch';
import { EAppMode } from 'src/utils/appMode';
import { LoadingWrapper } from 'src/components/LoadingWrapper';
import { LocationSearch } from 'src/components/LocationSearch';
import { MapSidebarList } from 'src/components/MapSidebar/components/MapSidebarCommunitiesList';
import { TMyCommunitiesProps } from './MyCommunities.types';
import s from './MyCommunities.module.scss';
import { selectAppMode } from 'src/redux/application/application.selectors';
import { useListCommunityInfoQuery } from 'src/graphql';
import { useSelector } from 'react-redux';
import vars from 'src/assets/styles/utils/vars.module.scss';

export const MyCommunities: React.FC<TMyCommunitiesProps> = () => {
  const { loading } = useListCommunityInfoQuery();
  const [searchQuery, setSearchQuery] = useState('');
  const appMode = useSelector(selectAppMode);

  const handleGoClicked = () => {
    // handling goes here TODO remove console.log later
  };

  return (
    <LoadingWrapper loading={loading}>
      {() => (
        <div className={s.container}>
          {appMode === EAppMode.Mobile ? (
            <BaseSearch
              name="communitiesSearch"
              theme="filled-gray"
              value={searchQuery}
              onChange={({ value }) => setSearchQuery(value)}
              label="Search by name"
              iconRight="search"
              iconRightColor={vars['color-black']}
            />
          ) : (
            <LocationSearch
              dropdownClassName={s.locationSearch}
              name="location"
              theme="filled-gray"
              flyAfterSelect
            />
          )}
          <BaseBanner
            iconStart={'atom'}
            textHeading="Bring your simulations closer to reality"
            text="Connects assets, use realtime data and trade"
            cta={{ label: 'Go', handler: handleGoClicked }}
          />
          <MapSidebarList
            mobileListClassName={s.list}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </div>
      )}
    </LoadingWrapper>
  );
};
